import {
  CDatePicker,
  CFormCheck,
  CFormInput,
  CFormRange,
  CFormSelect,
  CInputGroup,
  CInputGroupText,
  CMultiSelect,
} from '@coreui/react-pro'
import moment from 'moment/moment'
import React, { useEffect, useState } from 'react'
import PlusMinus from 'src/components/common/PlusMinus/PlusMinus'
import TabInputs from 'src/components/common/TabInputs/TabInputs'
import { convertHyphenDateToSlashDate } from '../utils/sharedFunctions'
import { debouncer } from '../views/pages/SidePanel/SideEncounterComponents/sharedPanelComponents/sharedAIfunctions'

export function dynamicInputGenerator(data, section, inputOnChange, tabData, setTabData) {
  let InputComp

  switch (data === null || data === undefined ? undefined : data.inputType) {
    case 'textarea':
      InputComp = (
        <TextArea
          data={data}
          label={data?.label}
          placeholder={data?.placeholder}
          onChange={inputOnChange}
        />
      )
      break
    case 'text':
      InputComp = (
        <TextBox
          data={data}
          label={data?.label}
          placeholder={data?.placeholder}
          onChange={inputOnChange}
        />
      )
      break
    case 'select':
      InputComp = <SelectBox input={data} onChange={inputOnChange} />
      break
    case 'custom':
      if (data.checkbox || data.inputs) {
        InputComp = (
          <CheckboxFields
            label={data.label}
            onChange={(inputs, value) => {
              inputOnChange({ ...data, inputs: inputs, value: value })
            }}
            hasInput={data?.inputs}
            hasCheckBox={data.checkbox}
            data={data}
            checked={data?.isChecked}
            inputOnChange={inputOnChange}
          />
        )
      }
      break
    case 'checkbox':
      InputComp = (
        <CheckboxFields
          label={data?.label}
          onChange={inputOnChange}
          hasInput={data?.inputs}
          data={data}
          checked={data?.isChecked}
          hasCheckBox={true}
        />
      )
      break
    case 'label':
      InputComp = <label className="txtbox-lbl-inner">{data?.label}</label>
      break
    case 'range':
      InputComp = (
        <>
          {data?.tabIndex !== undefined && data?.tabIndex === tabData && (
            <CFormRange
              id={data?.label}
              label={data?.label}
              {...data}
              onChange={(e) => inputOnChange({ ...data, value: e?.currentTarget?.value })}
            />
          )}
        </>
      )
      break
    case 'calendar':
      InputComp = <CalendarInput {...data} data={data} onChange={inputOnChange} />
      break
    case 'tabs':
      InputComp = (
        <TabInputs tabList={data?.options} setSelectedTab={setTabData} selectedTab={tabData} />
      )
      break
    case 'plusminus':
      InputComp = <PlusMinusWithLabel input={data} onChange={inputOnChange} />
      break
    default:
      InputComp = <div></div>
      break
  }
  return InputComp
}

function CalendarInput({ label, placeholder, onChange, data }) {
  const [thidDate, setthidDate] = useState(
    data?.value ? new Date(convertHyphenDateToSlashDate(data?.value)) : null,
  )

  const onDateSelect = () => {
    onChange({
      ...data,
      value: moment(thidDate).format('YYYY-MM-DD'),
    })
  }

  useEffect(() => {
    if (thidDate) {
      onDateSelect()
    }
  }, [thidDate])

  return (
    <div className="calender-holder">
      <label> {label} </label>
      <CDatePicker
        className="calender-date"
        date={thidDate}
        onConfirm={onDateSelect}
        onDateChange={(date) => setthidDate(date)}
        placeholder={placeholder}
        footer
        format="M/d/yyyy"
      />
    </div>
  )
}

function TextArea({ label, placeholder, onChange, data, disabled }) {
  const [textValue, setTextValue] = useState(data?.value || '')

  useEffect(() => {
    setTextValue(data?.value || '')
  }, [data?.value])

  return (
    <div className="input-group">
      {label && <label className="txtbox-lbl-inner">{label}</label>}
      <textarea
        className="form-control input-box"
        id={'TA' + Math.floor(Math.random() * 100000) + 1}
        value={textValue}
        placeholder={placeholder}
        disabled={disabled}
        rows="3"
        onChange={(e) => {
          const newText = e.currentTarget.value
          setTextValue(newText)

          debouncer(() =>
            onChange({
              ...data,
              value: newText,
            }),
          )
        }}
      ></textarea>
    </div>
  )
}

function TextBox({ label, placeholder, onChange, data, disabled }) {
  const [textValue, setTextValue] = useState(data?.value || '')

  useEffect(() => {
    setTextValue(data?.value || '')
  }, [data?.value])

  return (
    <div className="input-group">
      {label && <label className="txtbox-lbl-inner">{label}</label>}
      <CInputGroup className="flex-group">
        <CFormInput
          className="form-control input-box"
          value={textValue}
          placeholder={placeholder}
          disabled={disabled}
          type="text"
          onChange={(e) => {
            const newText = e.currentTarget.value
            setTextValue(newText)

            debouncer(() =>
              onChange({
                ...data,
                value: newText,
              }),
            )
          }}
        ></CFormInput>
        {data?.uom && <CInputGroupText>{data?.uom}</CInputGroupText>}
      </CInputGroup>
    </div>
  )
}

export function SelectBox({ input, onChange }) {
  return (
    <div className="">
      {input?.multiple ? (
        <CMultiSelect
          aria-label={input?.label || input?.placeholder}
          label={input?.label || (input?.placeholder !== '(tap)' ? input?.placeholder : '')}
          placeholder={input?.placeholder}
          options={input?.selectValues?.map((item) => ({ text: item, value: item }))}
          selectionType="tags"
          onChange={(value) => {
            let valueList = value?.map((item) => item?.value)

            if (onChange) {
              onChange({ ...input, value: valueList })
            }
          }}
        />
      ) : (
        <CFormSelect
          aria-label={input?.label || input?.placeholder}
          label={input?.label || input?.placeholder}
          placeholder={input?.placeholder}
          onChange={(e) => {
            const newVal =
              e?.currentTarget?.value === input?.placeholder ? '' : e?.currentTarget?.value

            if (onChange) {
              onChange({ ...input, value: newVal })
            }
          }}
        >
          <option>{input?.placeholder}</option>
          {input?.selectValues?.map((item, index) => (
            <option value={item} key={index}>
              {item}
            </option>
          ))}
        </CFormSelect>
      )}
    </div>
  )
}

const onCheckboxInputChange = (e, input, index, onKeyType) => {
  let value = e.currentTarget.value
  let max = e?.currentTarget?.getAttribute('max')
  let min = e?.currentTarget?.getAttribute('min')

  if (value === '') {
    onKeyType({ ...input, value: value }, index)
  } else {
    if (max && min) {
      if (value !== '-') {
        if (parseInt(value) >= parseInt(min) && parseInt(value) <= parseInt(max)) {
          onKeyType({ ...input, value: value }, index)
        }
      }
    } else {
      onKeyType({ ...input, value: value }, index)
    }
  }
}

function CheckboxFields({
  checked,
  data,
  hasInput,
  inputOnChange,
  onChange,
  hasCheckBox,
  label,
  disabled,
}) {
  const [thidDate, setthidDate] = useState()

  const onKeyType = (value, index) => {
    if (hasInput) {
      let tempData = [...hasInput]
      tempData[index] = value
      onChange(tempData, Boolean(checked))
    }
  }

  return (
    <div className={`checkbox-holder ${hasCheckBox ? '' : 'no-check'}`}>
      {hasCheckBox ? (
        <CFormCheck
          className="input-box"
          checked={Boolean(checked)}
          label={label}
          id={label}
          onChange={(e) => {
            if (hasInput) {
              inputOnChange({
                ...data,
                isChecked: Boolean(e?.currentTarget?.checked),
              })
            } else {
              onChange({
                ...data,
                isChecked: Boolean(e?.currentTarget?.checked),
                value: Boolean(e?.currentTarget?.checked),
              })
            }
          }}
        />
      ) : (
        <label>{label}</label>
      )}

      {Boolean(checked) || !hasCheckBox ? (
        <>
          {hasInput &&
            hasInput?.map((input, index) =>
              input?.inputType === 'calendar' ? (
                <div key={index}>
                  <CDatePicker
                    key={index}
                    className="calender-date"
                    date={convertHyphenDateToSlashDate(input?.value || thidDate)}
                    onConfirm={() =>
                      onKeyType({ ...input, value: moment(thidDate).format('YYYY-MM-DD') }, index)
                    }
                    onDateChange={(date) => {
                      let newDate = date ? moment(date).format('YYYY-MM-DD') : null
                      setthidDate(newDate)
                      onKeyType({ ...input, value: newDate }, index)
                    }}
                    placeholder={input.placeholder}
                    footer
                    format="M/d/yyyy"
                  />
                </div>
              ) : input?.inputType === 'range' ? (
                <CFormRange
                  id={input?.label}
                  key={index}
                  label={input?.label}
                  {...input}
                  onChange={(e) => {
                    const value = e?.currentTarget?.value
                    let tempData = [...hasInput]

                    tempData[index] = { ...tempData[index], value: value }

                    inputOnChange({ ...data, inputs: tempData })
                  }}
                />
              ) : input?.inputType === 'plusminus' ? (
                <PlusMinus
                  onChange={(value, index) => {
                    let tempData = [...hasInput]

                    tempData[index] = { ...tempData[index], ...value }

                    inputOnChange({ ...data, inputs: tempData })
                  }}
                  index={index}
                  defultValue={
                    input?.minus || input?.plus ? { minus: input?.minus, plus: input?.plus } : false
                  }
                />
              ) : input?.inputType === 'select' ? (
                input?.multiple ? (
                  <CMultiSelect
                    aria-label={input?.placeholder}
                    label={input?.placeholder}
                    placeholder={input?.placeholder}
                    options={input?.selectValues?.map((item) => ({ text: item, value: item }))}
                    selectionType="tags"
                    onChange={(value) => {
                      let valueList = value?.map((item) => item?.value)

                      let tempData = [...hasInput]

                      tempData[index] = { ...tempData[index], value: valueList }

                      inputOnChange({ ...data, inputs: tempData })
                    }}
                  />
                ) : (
                  <CFormSelect
                    aria-label={input?.placeholder}
                    label={input?.placeholder}
                    placeholder={input?.placeholder}
                    onChange={(e) => {
                      const value =
                        e?.currentTarget?.value === input?.placeholder
                          ? ''
                          : e?.currentTarget?.value
                      let tempData = [...hasInput]

                      tempData[index] = { ...tempData[index], value: value }

                      inputOnChange({ ...data, inputs: tempData })
                    }}
                  >
                    <option>{input?.placeholder}</option>
                    {input?.selectValues?.map((item, index) => (
                      <option value={item} key={index}>
                        {item}
                      </option>
                    ))}
                  </CFormSelect>
                )
              ) : (
                <CInputGroup key={index} className="flex-group">
                  <CFormInput
                    className={`dy-input-box`}
                    onChange={(e) => onCheckboxInputChange(e, input, index, onKeyType)}
                    placeholder={input.placeholder}
                    value={input?.value || ''}
                    type={input.inputType === 'numpad-decimal' ? 'number' : 'text'}
                    disabled={!hasCheckBox ? false : disabled || !Boolean(checked)}
                    {...input?.settings}
                    onFocus={(e) =>
                      e.target.addEventListener(
                        'wheel',
                        function (e) {
                          e.preventDefault()
                        },
                        { passive: false },
                      )
                    }
                    onKeyDown={(e) =>
                      input.inputType === 'numpad-decimal'
                        ? e?.keyCode === 69
                          ? e.preventDefault()
                          : null
                        : null
                    }
                  />
                  {input?.uom && <CInputGroupText>{input?.uom}</CInputGroupText>}
                </CInputGroup>
              ),
            )}
        </>
      ) : (
        <>
          {hasInput &&
            hasInput?.map((input, index) => (
              <label className={`disabled`} key={index}>
                {input?.value || input?.placeholder}
              </label>
            ))}
        </>
      )}
    </div>
  )
}

export function PlusMinusWithLabel({ input, onChange }) {
  const onPlusMinus = (value) => {
    if (onChange) {
      onChange({ ...input, ...value })
    }
  }

  return (
    <div className={`checkbox-holder no-check`}>
      <label>{input?.label}</label>
      <PlusMinus
        onChange={onPlusMinus}
        defultValue={
          input?.minus || input?.plus ? { minus: input?.minus, plus: input?.plus } : false
        }
      />
    </div>
  )
}
